// src/pages/Users/Inscription/components/GroupSelectionPanel.jsx

import React from "react";
import { FaLayerGroup } from "react-icons/fa";

import StepCard from "./StepCard";
import GroupChoiceCard from "./GroupChoiceCard";
import SelectedGroupCard from "./SelectedGroupCard";

export default function GroupSelectionPanel({
  disabled,
  dojos,
  dojosById,
  selectedDojo,
  setSelectedDojo,
  groups,
  selectedGroups,
  onAddGroup,
  onRemoveGroup,
  onOpenGroupDetails,
  groupError,
  isQuotaActive,
  canRegisterToGroup,
  getGroupUnavailableReason,
}) {
  return (
    <StepCard
      step="2"
      title="Choix du lieu et du groupe"
      icon={<FaLayerGroup />}
      description="Les groupes fermés restent visibles mais ne peuvent pas être sélectionnés."
    >
      {disabled ? (
        <div className="rounded-3xl border border-amber-200 bg-amber-50 p-4 text-sm font-medium text-amber-800 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-200">
          Choisissez d’abord le type d’inscription à l’étape 1.
        </div>
      ) : (
        <div className="space-y-5">
          <div className="grid gap-4 lg:grid-cols-[320px_1fr]">
            <div>
              <label className="mb-2 block text-sm font-bold text-slate-700 dark:text-slate-200">
                Lieu de pratique *
              </label>

              <select
                value={selectedDojo}
                onChange={(event) => setSelectedDojo(event.target.value)}
                className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
              >
                <option value="">Tous les lieux</option>
                {dojos.map((dojo) => (
                  <option key={dojo.id} value={dojo.id}>
                    {dojo.dojo_nom}
                  </option>
                ))}
              </select>
            </div>

            <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/70">
              <p className="text-sm leading-6 text-slate-600 dark:text-slate-300">
                Sélection rapide : les cartes affichent uniquement le nom du
                groupe et les années de naissance. Cliquez sur{" "}
                <span className="font-bold">Détails</span> pour ouvrir le
                panneau complet.
              </p>
            </div>
          </div>

          {groupError ? (
            <div className="rounded-3xl border border-rose-200 bg-rose-50 p-4 text-sm font-bold text-rose-700 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
              {groupError}
            </div>
          ) : null}

          {selectedGroups.length > 0 ? (
            <div>
              <h3 className="mb-3 text-sm font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
                Groupe(s) sélectionné(s)
              </h3>

              <div className="grid gap-4 lg:grid-cols-2">
                {selectedGroups.map((group) => (
                  <SelectedGroupCard
                    key={group.id}
                    group={group}
                    dojo={dojosById[String(group.dojo_id)]}
                    onRemove={() => onRemoveGroup(group.id)}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div className="rounded-3xl border border-dashed border-slate-300 bg-slate-50 p-5 text-sm text-slate-600 dark:border-slate-700 dark:bg-slate-950/60 dark:text-slate-300">
              Aucun groupe sélectionné pour le moment.
            </div>
          )}

          <div>
            <h3 className="mb-3 text-sm font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Groupes disponibles
            </h3>

            {groups.length ? (
              <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
                {groups.map((group) => (
                  <GroupChoiceCard
                    key={group.id}
                    group={group}
                    dojo={dojosById[String(group.dojo_id)]}
                    isQuotaActive={isQuotaActive}
                    disabled={!canRegisterToGroup(group)}
                    unavailableReason={getGroupUnavailableReason(group)}
                    onSelect={() => onAddGroup(group)}
                    onOpenDetails={() => onOpenGroupDetails(group)}
                  />
                ))}
              </div>
            ) : (
              <div className="rounded-3xl border border-slate-200 bg-slate-50 p-5 text-sm text-slate-600 dark:border-slate-800 dark:bg-slate-950/70 dark:text-slate-300">
                Aucun groupe trouvé pour ce lieu.
              </div>
            )}
          </div>
        </div>
      )}
    </StepCard>
  );
}